import * as React from 'react';

import { cn } from '../../lib/cn';

/** The unread count: a teal gradient lozenge with dark ink, per the design. */
export const CountBadge = React.forwardRef(({ className, count, ...props }, ref) => {
  if (!count) return null;
  return (
    <span
      ref={ref}
      className={cn(
        'inline-flex h-5 min-w-[22px] items-center justify-center rounded-[50px] px-[7px]',
        'bg-gradient-to-b from-dusq-accent-from to-dusq-accent',
        'font-dusq text-[10px] font-bold text-dusq-accent-ink',
        className
      )}
      {...props}
    >
      {count}
    </span>
  );
});
CountBadge.displayName = 'CountBadge';
